import { Outlet } from 'react-router-dom';
import Header from '../../components/layout/header';
import Footer from '../../components/layout/footer';

export default function Layout() {
    return (
        <div className="min-h-screen flex flex-col">
            <Header />

            <main className="flex-1">
                <Outlet />   {/* Nội dung của từng trang sẽ được render vào đây */}
            </main>

            {/* Footer đơn giản (tùy chọn) */}
            <Footer />
        </div>
    );
}